import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import CacheService from '../../services/cacheService';

export default class StripeError extends Component {

  render () {
    return (
      <div>
        <div className='col-xs-12 col-md-12 col-lg-12'>
          <div className='info-box'>
            <h3>No Stripe Account Setup.</h3>
            <p>Please contact your club.</p>
            <Link to={`/${CacheService.getToken().bname}/`} className='btn btn-primary' >Go To Home Screen</Link>
          </div>
        </div>
      </div>
    )
  }
}
